<template>
  <tk-container :status="status">
    <!-- <tkui-header
      slot="header"
      center
      class="primary-header"
    >{{title}}</tkui-header> -->
    <div class="agreement-box" v-if="privacyNotice" v-html="privacyNotice"></div>
  </tk-container>
</template>

<script>
const uTitle = '用户协议'
const uUrl = 'https://cloud.light-health.mokekeji.com/settings/userprotocol'
const pTitle = '隐私协议'
const pUrl = 'https://cloud.light-health.mokekeji.com/settings/privacyprotocol'
export default {
  data () {
    return {
      privacyNotice: '',
      status: 'loading',
      title: ''
    }
  },
  methods: {
    async getData (url) {
      try {
        const privacyPolicy = await this.$tkParse.get(url)
        if (privacyPolicy.data) { this.privacyNotice = privacyPolicy.data } else { this.privacyNotice = null }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  },
  mounted () {
    console.log()
    const query = this.$route.query
    if (query.target === 'u') {
      this.title = uTitle
      document.title = '有光万物用户协议'
      this.getData(uUrl)
    } else if (query.target === 'p') {
      document.title = '有光万物隐私协议'
      this.title = pTitle
      this.getData(pUrl)
    }
  }
}
</script>

<style scoped lang="scss">
  .agreement-box {
    background: #fff;
    padding: 15px;
  }
  .primary-header {
    border-bottom: 1px solid #f5f5f5;
    background: #fff;
    color: #000000;
  }
</style>
